angular.module('env.data.models.workflowAuditRecordModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("WorkflowAuditRecordModel",
            {
                extend: ['IdModel'],
                fields: {
                    userName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    orderId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    orderItemId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    stepCode: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    actionCode: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    actionExecutionDate: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    lastActionExecutionDate: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    secondsSinceLastActionExecution: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    actionProcessor: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    actionProcessorData: {
                        type: RepresentationModelFieldTypes.STRING
                    }
                }
            }
        );
    })

;
